import { render, staticRenderFns } from "./Zip3Serve.vue?vue&type=template&id=25240505&scoped=true"
import script from "./Zip3Serve.vue?vue&type=script&lang=ts"
export * from "./Zip3Serve.vue?vue&type=script&lang=ts"
import style0 from "./Zip3Serve.vue?vue&type=style&index=0&id=25240505&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25240505",
  null
  
)

export default component.exports